import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './_guards';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
// import { AgenciesListComponent } from './agencies-list/agencies-list.component';
// import { AgencyPageComponent } from './agency-page/agency-page.component';
// import { AgentPageComponent } from './agent-page/agent-page.component';
// import { AgentsListComponent } from './agents-list/agents-list.component';
// import { BlogFullWidthSinglePostComponent } from './blog-full-width-single-post/blog-full-width-single-post.component';
// import { BlogPostComponent } from './blog-post/blog-post.component';
// import { BlogComponent } from './blog/blog.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ContactComponent } from './contact/contact.component';
// import { MyBookmarksComponent } from './my-bookmarks/my-bookmarks.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { MyPropertiesComponent } from './my-properties/my-properties.component';
import { SubmitPropertyComponent } from './submit-property/submit-property.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { RegistrationComponent } from './registration/registration.component';
import { InformationComponent} from './registration/information/information.component';
// import { PreviousRouteGuard } from './_guards/PreviousRouteGuard';
// import { PaginationPracticeComponent } from './pagination-practice/pagination-practice.component';
import { ApproveComponent } from './property/approve/approve.component';
import { RejectComponent } from './property/reject/reject.component';
import { PropertiesComponent } from './Properties/Properties.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AboutUsComponent } from './about-us/about-us.component';
// import { ListingsListWithSidebarComponent } from './listings-list-with-sidebar/listings-list-with-sidebar.component';
import { PropertyDetailsComponent } from './property-details/property-details.component';
import { ProfileEditComponent } from './Profile/profile-edit/profile-edit.component';
import { ConfirmationComponent } from './registration/confirmation/confirmation.component';
import { ContactsComponent } from './marketing/contacts/contacts.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

const routes: Routes = [
  { 
    path: '', 
    component: HomeComponent,
    data: { 
      seo: { 
        title: 'Home', 
        description: 'Find your dream home in Pakistan with pakmatti.com. Search thousands of real estate listings.' 
      } 
    }
  },
  { 
    path: 'home', 
    component: HomeComponent,
    data: { 
      seo: { 
        title: 'Home', 
        description: 'Find your dream home in Pakistan with pakmatti.com. Search thousands of real estate listings.' 
      } 
    }
  },
  { 
    path: 'login-register', 
    component: LoginComponent,
    data: { 
      seo: { 
        title: 'Login or Register', 
        description: 'Login or create an account on pakmatti.com to manage your property listings and bookmarks.' 
      } 
    }
  },
  { path: 'login-register%3FreturnUrl%3D%252F', component: LoginComponent },
  { 
    path: 'contact-us', 
    component: ContactComponent,
    data: { 
      seo: { 
        title: 'Contact Us', 
        description: 'Get in touch with pakmatti.com for any real estate inquiries or support.' 
      } 
    }
  },
  { 
    path: 'about-us', 
    component: AboutUsComponent,
    data: { 
      seo: { 
        title: 'About Us', 
        description: 'Learn more about pakmatti.com, Pakistan\'s leading real estate portal.' 
      } 
    }
  },
  { 
    path: 'privacy-policy', 
    component: PrivacyPolicyComponent,
    data: { 
      seo: { 
        title: 'Privacy Policy', 
        description: 'Read the privacy policy of pakmatti.com regarding user data and protection.' 
      } 
    }
  },
  { 
    path: 'properties', 
    component: PropertiesComponent,
    data: { 
      seo: { 
        title: 'Properties Listing', 
        description: 'Explore the latest real estate properties for sale and rent in Pakistan.' 
      } 
    }
  },
  { path: 'account/profile', component: MyProfileComponent },
  { path: 'account/profile/edit', component: ProfileEditComponent },
  { path: 'account/properties', component: MyPropertiesComponent, canActivate: [AuthGuard] },
  { path: 'account/change-password', component: ChangePasswordComponent, canActivate: [AuthGuard] },
  { 
    path: 'property/:propertyUrl', 
    component: PropertyDetailsComponent 
  },
  { path: 'property/forms/submit', component: SubmitPropertyComponent },
  { path: 'property/forms/submit/:id', component: SubmitPropertyComponent, canActivate: [AuthGuard] },
  { path: 'property/verification/approve', component: ApproveComponent },
  { path: 'property/verification/reject', component: RejectComponent },
  { path: 'forgot-password', component: ForgetPasswordComponent },
  { path: 'registration', component: RegistrationComponent },
  { path: 'registration/information', component: InformationComponent },
  { path: 'registration/confirmation', component: ConfirmationComponent },
  { 
    path: 'terms-and-conditions', 
    component: TermsAndConditionsComponent,
    data: { 
      seo: { 
        title: 'Terms and Conditions', 
        description: 'Read the terms and conditions for using pakmatti.com services.' 
      } 
    }
  },
  { path: 'marketing/contacts', component: ContactsComponent, canActivate: [AuthGuard] },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
